// RD 95803 - permitir colar/enviar imagem dentro do campo de texto rico.
//
// Antes, o botao de imagem da toolbar so aceitava URL: o usuario precisava hospedar a
// imagem em algum lugar e colar o link. Aqui a imagem e enviada pelo MESMO endpoint de
// upload que o restante do Admin ja usa (POST api/v1/upload/{pasta}), e o editor recebe
// de volta a URL publica do storage.
//
// Nao guardamos a imagem em base64 dentro do proprio HTML de proposito: o campo
// PopUps.Mensagem e nvarchar(max) e aceitaria, mas cada pop-up passaria a trafegar a
// imagem inteira embutida em toda listagem e em toda exibicao no portal.

import { AtomicBlockUtils, EditorState } from "draft-js";
import ApiServices from "../../services/apiServices";

const TAMANHO_MAXIMO = 5 * 1024 * 1024; // 5 MB
const TIPOS_ACEITOS = "image/png,image/jpeg,image/jpg,image/gif,image/webp";

export const MENSAGEM_TIPO = "Só é possível inserir imagens (PNG, JPG, GIF ou WEBP).";
export const MENSAGEM_TAMANHO = "A imagem precisa ter no máximo 5 MB.";
export const MENSAGEM_FALHA = "Não foi possível enviar a imagem. Tente novamente.";

// Sobe o arquivo e devolve a URL publica. Lanca Error com mensagem pronta para o toast.
export async function enviarImagem(arquivo, pasta) {
  if (!arquivo || !arquivo.type || !arquivo.type.startsWith("image/")) {
    throw new Error(MENSAGEM_TIPO);
  }
  if (arquivo.size > TAMANHO_MAXIMO) {
    throw new Error(MENSAGEM_TAMANHO);
  }

  const formData = new FormData();
  formData.append("file", arquivo, arquivo.name || "imagem.png");

  const resposta = await ApiServices.apiUpload(`upload/${pasta}`, formData);
  const url = resposta && resposta.data;
  if (!url) {
    throw new Error(MENSAGEM_FALHA);
  }
  return url;
}

// Configuracao do botao de imagem da toolbar.
// urlEnabled = false porque a PO confirmou (14/09/2026) que a opcao de inserir por link
// "pode ser substituida" pelo envio direto do arquivo.
export function toolbarComImagem(pasta) {
  return {
    image: {
      uploadEnabled: true,
      urlEnabled: false,
      previewImage: true,
      inputAccept: TIPOS_ACEITOS,
      alt: { present: false, mandatory: false },
      defaultSize: { height: "auto", width: "auto" },
      uploadCallback: (arquivo) =>
        enviarImagem(arquivo, pasta).then((link) => ({ data: { link } })),
    },
  };
}

// Insere a imagem no ponto onde o cursor esta.
function inserirImagem(editorState, url) {
  const conteudo = editorState.getCurrentContent().createEntity("IMAGE", "MUTABLE", {
    src: url,
    height: "auto",
    width: "auto",
  });
  const entityKey = conteudo.getLastCreatedEntityKey();
  // precisa reaplicar o content devolvido por createEntity, senao a entidade se perde
  const comEntidade = EditorState.set(editorState, { currentContent: conteudo });
  return AtomicBlockUtils.insertAtomicBlock(comEntidade, entityKey, " ");
}

// Handler de Ctrl+V com imagem no clipboard (print de tela, copiar imagem etc.).
// Vai em <Editor editorProps={{ handlePastedFiles: colarImagem(...) }} />.
// Devolver "handled" impede o draft-js de colar o arquivo como texto.
export function colarImagem(pasta, setEditorState, aoFalhar) {
  return (arquivos) => {
    const imagem = Array.from(arquivos || []).find(
      (a) => a && a.type && a.type.startsWith("image/")
    );
    if (!imagem) return "not-handled";

    enviarImagem(imagem, pasta)
      .then((url) => setEditorState((anterior) => inserirImagem(anterior, url)))
      .catch((erro) => {
        if (aoFalhar) aoFalhar(erro && erro.message ? erro.message : MENSAGEM_FALHA);
      });

    return "handled";
  };
}
